import { baseURL } from './request'
import { noticeTagMap, NoticeTag } from './noticeTag'
import { router } from '@/router/index'

/** 在开发环境加上代理前缀 */
export function getAssetsUrl(url: string) {
  if (url.indexOf('data:') === 0) {
    return url
  }
  if (process.env.NODE_ENV === 'development') {
    url = baseURL + url
  }
  return url
}

/** 跳转公共详情页
 * @param noticeItem 整个文章对象
 */
export function toDetail(noticeItem: NoticeItem, path?: string) {
  const { manuscriptUrl, id, noticeTag } = noticeItem
  if (manuscriptUrl) {
    window.open(manuscriptUrl, '_blank')
    return false
  }

  const route = router.currentRoute

  if (noticeTag && typeof noticeTag === 'string' && !isNaN(Number(noticeTag))) {
    const tag = <NoticeTag>noticeTag
    path = noticeTagMap[tag]
  }
  if (!path) {
    path = route.path
  }

  router.push({
    path: `/detail/${id}`,
    query: {
      form: path,
    },
  })
}

export function toDetailBlank(noticeItem: NoticeItem, path?: string) {
  const { manuscriptUrl, id, noticeTag } = noticeItem
  if (manuscriptUrl) {
    window.open(manuscriptUrl, '_blank')
    return false
  }
  const route = router.currentRoute

  if (noticeTag && typeof noticeTag === 'string' && !isNaN(Number(noticeTag))) {
    const tag = <NoticeTag>noticeTag
    path = noticeTagMap[tag]
  }
  if (!path) {
    path = route.path
  }

  window.open(`/#/detail/${id}?form=${encodeURIComponent(path)}`, '_blank')
}

const re = new RegExp('<[^<>]+>', 'g')
/** 从富文本内提取纯文本 */
export function getHTMLText(html_str: string) {
  if (typeof html_str === 'string') {
    return html_str.replace(re, '').replace(/\&nbsp\;/g, ' ')
  }
  return ''
}
